<p-toast />
<p-confirmDialog #cd [style]="{width: '50vw'}">
    <ng-template pTemplate="footer">
        <button type="button" pButton icon="pi pi-times" label="No" (click)="cd.reject()"></button>
        <button type="button" pButton icon="pi pi-check" label="Si" (click)="cd.accept()"></button>
    </ng-template>
</p-confirmDialog>

<div class="container-ficha">
    <h2 style="text-align: center;">Caso clínico</h2>
    <p-tabView>
        <p-tabPanel header="Ficha">
            <form [formGroup]="fichaForm">
                <div class="formgrid grid">
                    <div class="field col-12 md:col-4">
                        <label for="folio">Folio *:</label>
                        <input type="text" id="folio" [readonly]="true"
                            class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                            pInputText formControlName="folio" />
                    </div>
                    <div class="field col-12 md:col-4">
                        <div *ngIf="isNuevo; else fechaFicha_label">
                            <label for="fecha">Fecha *:</label>
                            <p-calendar id="fecha" formControlName="fecha" dateFormat="dd/mm/yy"
                                [maxDate]="fechaFichaMax" placeholder="Ingrese la fecha" />
                        </div>
                        <ng-template #fechaFicha_label>
                            <label for="fechaFLabel">Fecha *:</label>
                            <input type="text" id="fechaFLabel" [readonly]="true" [disabled]="true"
                                class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                                pInputText [value]="fechaFichaLabel" />
                        </ng-template>
                    </div>
                    <div class="field col-12 md:col-4">
                        <label for="serie">Serie *:</label>
                        <input type="text" id="serie" [readonly]="true"
                            class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                            pInputText formControlName="serie" />
                    </div>
                    <div class="field col-12 md:col-4">
                        <label for="paciente">Paciente *:</label>
                        <input type="text" id="paciente" placeholder="Ingrese el paciente"
                            class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                            pInputText formControlName="paciente" />
                    </div>
                    <div class="field col-12 md:col-4">
                        <label for="edad">Edad *:</label>
                        <p-inputNumber formControlName="edad" inputId="Edad" placeholder="Ingrese la edad"
                            class="w-full" styleClass="inputnumber w-full" [maxlength]="2" [min]="1" [max]="99" />
                    </div>
                    <div class="field col-12 md:col-4">
                        <label for="sexo">Sexo *:</label>
                        <p-dropdown formControlName="sexo" id="sexo" [options]="tipoDropSexo" optionLabel="label"
                            optionValue="value" styleClass="w-full" placeholder="Seleccione un Sexo"
                            [emptyMessage]="'Sin resultados'" [emptyFilterMessage]="'Sin resultados'" />
                    </div>
                    <div class="field col-12 md:col-6">
                        <label for="institucion">Institución *:</label>
                        <p-dropdown formControlName="fk_institucion" id="institucion" [options]="instituciones"
                            optionLabel="label" optionValue="value" styleClass="w-full"
                            placeholder="Seleccione una Institución" [emptyMessage]="'Sin registros'"
                            [emptyFilterMessage]="'Sin resultados'" />
                    </div>
                    <div class="field col-12 md:col-6">
                        <label for="estado">Entidad Federativa *:</label>
                        <p-dropdown formControlName="fk_estado" id="estado" [options]="estados" optionLabel="label"
                            optionValue="value" styleClass="w-full" placeholder="Seleccione un Estado"
                            [emptyMessage]="'Sin resultados'" [emptyFilterMessage]="'Sin resultados'" />
                    </div>
                    <div class="field col-12 md:col-12 ">
                        <label for="hospital">Hospital *:</label>
                        <p-dropdown formControlName="fk_hospital" id="hospital" [options]="hospitales"
                            optionLabel="label" optionValue="value" styleClass="w-full"
                            placeholder="Seleccione un Hospital" [emptyMessage]="'Sin resultados'"
                            [emptyFilterMessage]="'Sin resultados'" />
                    </div>
                    <div class="field col-12 md:col-12">
                        <label for="diagnostico">Diagnóstico:</label>
                        <p-dropdown formControlName="fk_diagnostico" id="diagnostico" [options]="diagnosticos"
                            optionLabel="label" optionValue="value" styleClass="w-full"
                            placeholder="Seleccione un Diagnóstico" [emptyMessage]="'Sin resultados'"
                            [emptyFilterMessage]="'Sin resultados'" />
                    </div>
                    <div class="field col-12 md:col-6">
                        <label for="diagnostico">Antecedente: </label>
                        <textarea rows="5" cols="30" class="w-full" pInputTextarea
                            formControlName="antecedente"></textarea>
                    </div>
                </div>

                <div *ngIf="idCasoClinico=='0'" class="card flex justify-content-center">
                    <button pButton pRipple label="Guardar" (click)="guardarFicha()"></button>
                </div>
                <div *ngIf="idCasoClinico!='0'" class="card flex justify-content-center">
                    <button pButton pRipple label="Actualizar" (click)="actualizarFicha()"></button>
                </div>
            </form>
        </p-tabPanel>
        <p-tabPanel header="Cirugia" [disabled]="isNuevo">
            <form [formGroup]="cirugiaForm">
                <div class="formgrid grid">
                    <div class="field col-12 md:col-6">
                        <div *ngIf="(fechaCirugiaLabel === null)">
                            <div *ngIf="( diasPlazo >= diasTranscurridos ); else tiempo_caducado">
                                <label for="fechaAplicacionProducto" style="display: block;">Fecha aplicacion producto
                                    *:</label>
                                <p-calendar id="fechaAplicacionProducto" formControlName="fechaAplicacionProducto"
                                    dateFormat="dd/mm/yy" [minDate]="fechaCirugiaMin" [maxDate]="fechaCirugiaMax"
                                    [ngClass]="{'ng-invalid ng-dirty': cirugiaFrm['fechaAplicacionProducto'].touched && cirugiaFrm['fechaAplicacionProducto'].errors}" />
                                <small class="p-error"
                                    *ngIf="cirugiaFrm['fechaAplicacionProducto'].touched && cirugiaFrm['fechaAplicacionProducto'].errors?.['required']">
                                    La fecha aplicacion producto es requerido
                                </small>
                            </div>
                            <ng-template #tiempo_caducado>
                                <div>
                                    <p-messages [(value)]="message" [showTransitionOptions]="'500ms'"
                                        [hideTransitionOptions]="'500ms'" [enableService]="false"></p-messages>
                                </div>
                            </ng-template>

                        </div>
                        <div *ngIf="fechaCirugiaLabel">
                            <label for="fechaCLabel">Fecha aplicacion producto *:</label>
                            <input type="text" id="fechaCLabel" [readonly]="true" [disabled]="true"
                                class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                                pInputText [value]="fechaCirugiaLabel" />
                        </div>
                    </div>

                    <div class="field col-12 md:col-6">
                        <div *ngIf="(fechaCirugiaLabel == null)">
                            <p-messages [(value)]="messages" [showTransitionOptions]="'500ms'"
                                [hideTransitionOptions]="'500ms'" [enableService]="false"></p-messages>
                        </div>
                    </div>
                    <div class="field col-12 md:col-6">
                        <label for="uso">Uso del Producto *:</label>
                        <p-dropdown formControlName="fk_usoProducto" id="uso" [options]="usosProducto"
                            optionLabel="label" optionValue="value" styleClass="w-full"
                            placeholder="Seleccione un Uso de producto" [emptyMessage]="'Sin resultados'"
                            [emptyFilterMessage]="'Sin resultados'" />
                    </div>
                    <div class="field col-12 md:col-6">
                        <label for="cuerpo">Parte del Cuerpo*:</label>
                        <p-dropdown formControlName="fk_seccion_cuerpo" id="cuerpo" [options]="seccionesCuerpo"
                            optionLabel="label" optionValue="value" styleClass="w-full"
                            placeholder="Seleccione una parte del cuerpo" [emptyMessage]="'Sin resultados'"
                            [emptyFilterMessage]="'Sin resultados'"
                            [ngClass]="{'ng-invalid ng-dirty': cirugiaFrm['fk_seccion_cuerpo'].touched && cirugiaFrm['fk_seccion_cuerpo'].errors}" />
                        <small class="p-error"
                            *ngIf="cirugiaFrm['fk_seccion_cuerpo'].touched && cirugiaFrm['fk_seccion_cuerpo'].errors?.['required']">
                            La Parte del Cuerpo es requerido
                        </small>
                    </div>
                    <div class="field col-12 md:col-12">
                        <label for="acciones">Acciones*:</label>
                        <p-multiSelect formControlName="acciones" id="acciones" [options]="acciones" optionLabel="label"
                            optionValue="value" styleClass="w-full" display="chip"
                            placeholder="Seleccione las acciones" />
                    </div>
                    <div class="field col-12 md:col-6">
                        <label for="tratamiento">Tratamiento realizado*: </label>
                        <textarea id="tratamiento" rows="5" cols="30" class="w-full" pInputTextarea
                            formControlName="tratamiento"></textarea>
                    </div>

                    <div class="field col-12 md:col-4"></div>

                    <div class="field col-12 md:col-6">
                        <label for="antibiotico">Antibiotico utilizado:</label>
                        <p-dropdown formControlName="fk_antibiotico1" id="antibiotico" [options]="antibioticos"
                            optionLabel="label" optionValue="value" styleClass="w-full"
                            placeholder="Seleccione un Antibiotico" [emptyMessage]="'Sin resultados'"
                            [emptyFilterMessage]="'Sin resultados'" />
                    </div>
                    <div class="field col-12 md:col-6">
                        <label class="w-full" for="cantidad">Cantidad en (ml/mg):</label>
                        <p-inputNumber formControlName="cantidad1" inputId="cantidad" styleClass="inputnumber"
                            [maxlength]="2" [min]="5" [max]="50" />
                    </div>
                    <div class="field col-12 md:col-6">
                        <label for="antibiotico2">2do Antibiotico utilizado:</label>
                        <p-dropdown formControlName="fk_antibiotico2" id="antibiotico2" [options]="antibioticos"
                            optionLabel="label" optionValue="value" styleClass="w-full"
                            placeholder="Seleccione un Antibiotico" [emptyMessage]="'Sin resultados'"
                            [emptyFilterMessage]="'Sin resultados'" />
                    </div>
                    <div class="field col-12 md:col-6">
                        <label class="w-full" for="cantidad2">Cantidad en (ml/mg):</label>
                        <p-inputNumber formControlName="cantidad2" inputId="cantidad2" styleClass="inputnumber"
                            [maxlength]="2" [min]="5" [max]="50" />
                    </div>
                    <div class="field col-12 md:col-6">
                        <label for="antibiotico3">3er Antibiotico utilizado:</label>
                        <p-dropdown formControlName="fk_antibiotico3" id="antibiotico3" [options]="antibioticos"
                            optionLabel="label" optionValue="value" styleClass="w-full"
                            placeholder="Seleccione un Antibiotico" [emptyMessage]="'Sin resultados'"
                            [emptyFilterMessage]="'Sin resultados'" />
                    </div>
                    <div class="field col-12 md:col-6">
                        <label class="w-full" for="cantidad3">Cantidad en (ml/mg):</label>
                        <p-inputNumber formControlName="cantidad3" inputId="cantidad3" styleClass="inputnumber"
                            [maxlength]="2" [min]="5" [max]="50" />
                    </div>
                    <div class="field col-12 md:col-12">
                        <label for="observacion">Observaciones: </label>
                        <textarea id="observacion" rows="5" cols="30" class="w-full" pInputTextarea
                            formControlName="observacion"></textarea>
                    </div>

                </div>
                <div class="card flex justify-content-center">
                    <button pButton pRipple label="Guardar" [disabled]="!cirugiaForm.valid"
                        (click)="actualizarCirugia()"></button>
                </div>
            </form>
        </p-tabPanel>
        <p-tabPanel header="Productos" [disabled]="isNuevo">
            <section *ngIf="productos.length == 0">
                <form [formGroup]="codigoForm">
                    <div class="formgrid  grid">
                        <div class="field col-12 md:col-4">
                            <label for="codigo" style="margin-right: 5px;">Codigo *: </label>
                            <input type="text" id="codigo"
                                class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary"
                                placeholder="Ingrese el codigo" pInputText formControlName="codigo"
                                [ngClass]="{'ng-invalid ng-dirty': c['codigo'].touched && c['codigo'].errors}" />
                            <small class="p-error" *ngIf="c['codigo'].touched && c['codigo'].errors?.['required']">
                                El código es requerido
                            </small>

                        </div>
                        <div class="field col-12 md:col-4">
                            <button pButton pRipple label="Agregar Codigo"
                                [disabled]="!codigoForm.valid || fechaCirugiaLabel===null" class="p-button-sm"
                                (click)="getCodigo()"></button>
                        </div>
                    </div>
                </form>

                <p-table [value]="productosxAsignar" [tableStyle]="{ 'width': '75%', 'margin': 'auto' }">
                    <ng-template pTemplate="header">
                        <tr>
                            <th colspan="3" style="text-align:center;">Bandeja de Productos</th>
                        </tr>
                        <tr>
                            <th>Códigos</th>
                            <th>Producto</th>
                            <th>Acciones</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-producto>
                        <tr>
                            <td>{{ producto.codigo }}</td>
                            <td>{{ producto.nomProducto }}</td>
                            <td></td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                        <tr>
                            <td colspan="3">
                                Sin Productos
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
                <div class="card flex justify-content-center">
                    <button pButton pRipple label="Asignar Codigos" [disabled]="productosxAsignar.length == 0"
                        (click)="asignarCodigos()"></button>
                </div>
            </section>
            <section *ngIf="productos.length > 0">
                <p-table [value]="productos" [tableStyle]="{ 'min-width': '50rem' }">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Codigo</th>
                            <th>Producto</th>
                            <th></th>
                            <th></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-producto>
                        <tr>
                            <td>{{ producto.codigo }}</td>
                            <td>{{ producto.nomProducto }}</td>
                            <td></td>
                            <td></td>
                        </tr>
                    </ng-template>
                </p-table>
            </section>
        </p-tabPanel>
        <p-tabPanel header="Documentos" [disabled]="isNuevo">
            <div class="card">
                <form [formGroup]="documentoForm">
                    <div class="field">
                        <label for="tipoDoc">Tipo del documento</label>
                        <p-dropdown formControlName="fk_tipoDocumento" id="tipoDoc" [options]="tiposDocumentos"
                            optionLabel="label" optionValue="value" styleClass="w-full"
                            placeholder="Seleccione una tipo" [emptyMessage]="'Sin registros'"
                            [emptyFilterMessage]="'Sin registros'" />
                    </div>
                    <div class="field">
                        <label for="descripcion">Descripción del documento</label>
                        <textarea rows="5" cols="30" class="w-full" pInputTextarea
                            formControlName="descDocumento"></textarea>
                    </div>
                </form>
                <app-file-upload-minimalista (fileUploaded)="onFileUploaded($event)">
                </app-file-upload-minimalista>
            </div>

            <p-divider></p-divider>

            <p-table [value]="documentos" [tableStyle]="{ 'min-width': '50rem' }" [styleClass]="'p-datatable-sm'">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Descripción</th>
                        <th>Documento</th>
                        <th>Acciones</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-documento>
                    <tr>
                        <td>{{ documento.descDocumento }}</td>
                        <td><a [href]=" urlbase + documento.rutaPublica + '/' + documento.nomDocumento" target="_blank">
                                {{
                                documento.originalNomDocumento }}</a> </td>
                        <td>
                            <p-button icon="pi pi-trash"
                                styleClass="p-button-rounded p-button-danger p-button-text p-button-sm"
                                (click)="deleteSelectedDocumentos(documento.id)"></p-button>
                        </td>

                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                        <td colspan="3">
                            Sin Documentos
                        </td>
                    </tr>
                </ng-template>

            </p-table>

        </p-tabPanel>
    </p-tabView>
</div>